/* Baler Picker PDP Widget — vanilla JS, no dependencies.
   Loaded by snippets/baler-picker-pdp.liquid.
   Lazy-loads compatibility data on first expand, then on model selection
   resolves the matching XES SKU and clicks the corresponding variant radio. */
(function () {
  'use strict';

  var ROOT = document.getElementById('balenets-baler-picker');
  if (!ROOT) return;

  var triggerEl = ROOT.querySelector('.bpd-trigger');
  var bodyEl    = ROOT.querySelector('.bpd-body');
  var loadingEl = ROOT.querySelector('[data-bpd-loading]');
  var ctrlsEl   = ROOT.querySelector('[data-bpd-controls]');
  var brandEl   = ROOT.querySelector('[data-bpd-brand]');
  var modelEl   = ROOT.querySelector('[data-bpd-model]');
  var resultEl  = ROOT.querySelector('[data-bpd-result]');
  var DATA_URL  = window.__BALER_PDP_DATA_URL__;
  var VARIANTS  = window.__BALER_PDP_VARIANTS__ || {};

  var state = { loaded: false, rows: [], skus: {}, byBrand: {} };

  function track(eventName, params) {
    try {
      if (window.dataLayer) {
        window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params || {});
      }
    } catch (e) { /* noop */ }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'bpd-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { t.remove(); }, 300);
    }, 2200);
  }

  function loadData() {
    if (state.loaded) return Promise.resolve(state);
    return fetch(DATA_URL, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (json) {
        // The slim JSON is already pre-filtered to live-eligible rows (verified by checker publish step).
        // Keep all rows including `unsupported` so customers get an honest answer instead of
        // a phantom "model not in list".
        state.rows = (json.rows || []);
        state.skus = json.skus || {};
        var byBrand = {};
        state.rows.forEach(function (r) {
          if (!byBrand[r.brand]) byBrand[r.brand] = [];
          byBrand[r.brand].push(r);
        });
        Object.keys(byBrand).forEach(function (b) {
          byBrand[b].sort(function (a, b2) { return a.model.localeCompare(b2.model); });
        });
        state.byBrand = byBrand;
        state.loaded = true;
        return state;
      });
  }

  function populateBrands() {
    var brands = Object.keys(state.byBrand).sort();
    var html = '<option value="">— Select brand —</option>';
    brands.forEach(function (b) {
      html += '<option value="' + escapeHtml(b) + '">' + escapeHtml(b) + '</option>';
    });
    brandEl.innerHTML = html;
  }

  function populateModels(brand) {
    modelEl.innerHTML = '<option value="">— Select model —</option>';
    if (!brand || !state.byBrand[brand]) {
      modelEl.disabled = true;
      return;
    }
    state.byBrand[brand].forEach(function (r) {
      var opt = document.createElement('option');
      opt.value = r.id;
      var label = r.model + (r.year_range ? ' (' + r.year_range + ')' : '');
      if (r.verified_status === 'unconfirmed') label += ' — verification pending';
      opt.textContent = label;
      modelEl.appendChild(opt);
    });
    modelEl.disabled = false;
  }

  function findVariantBySku(sku) {
    if (!sku) return null;
    var v = VARIANTS[sku.toUpperCase()];
    return v || null;
  }

  function clickVariantRadio(option1Value) {
    // Strategy 1: radio input by option1 value
    var radios = document.querySelectorAll('variant-selects input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === option1Value && !radios[i].disabled) {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        radios[i].click();
        return true;
      }
    }
    // Strategy 2: select dropdown
    var sel = document.querySelector('variant-selects select');
    if (sel) {
      sel.value = option1Value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  function applyVariant(sku, displayName) {
    var v = findVariantBySku(sku);
    if (!v) return false;
    var ok = clickVariantRadio(v.option1);
    if (ok) {
      toast('Selected ' + (displayName || v.option1));
      track('baler_picker_pdp_apply', { sku: sku, variant_id: v.id });
      // Smoothly bring the buy-button area into view if not visible
      var buy = document.querySelector('product-form, .product-form, [name="add"]');
      if (buy) {
        var rect = buy.getBoundingClientRect();
        if (rect.top < 0 || rect.top > window.innerHeight - 100) {
          buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    } else {
      // Fallback: hard navigate
      window.location.search = '?variant=' + v.id;
    }
    return ok;
  }

  function skuLabel(sku) {
    if (!sku) return '';
    var v = VARIANTS[sku.toUpperCase()];
    var label = v && v.option1 ? v.option1 : sku;
    return label + ' (SKU ' + sku + ')';
  }

  function skuShort(sku) {
    var v = VARIANTS[sku.toUpperCase()];
    return v && v.option1 ? v.option1 : sku;
  }

  function renderResult(row) {
    if (!row) { resultEl.innerHTML = ''; return; }
    var primary = row.recommended_sku;
    var alt     = row.alternate_sku;
    var fit     = row.fit_type || 'single';
    var pillCls = 'fit-direct', pillTxt = 'Direct fit';
    var cardCls = '';
    if (fit === 'either')           { pillCls = 'fit-either'; pillTxt = 'Either size'; cardCls = 'bpd-r-either'; }
    else if (fit === 'depends_on_kit') { pillCls = 'fit-kit'; pillTxt = 'Needs kit'; cardCls = 'bpd-r-kit'; }
    else if (fit === 'unsupported')  { pillCls = 'fit-unsup'; pillTxt = 'Not supported'; cardCls = 'bpd-r-unsupported'; }

    var html = '<div class="bpd-result ' + cardCls + '">';
    html += '<div><strong>' + escapeHtml(row.brand + ' ' + row.model) + '</strong>';
    html += '<span class="bpd-pill ' + pillCls + '">' + pillTxt + '</span></div>';

    if (row.verified_status === 'unconfirmed' && fit !== 'unsupported') {
      html += '<div class="bpd-pending"><strong>Verification pending.</strong> Single-source recommendation. Please confirm with your operator manual before running production volumes.</div>';
    }

    if (fit === 'unsupported') {
      html += '<div style="margin-top:6px;">This baler isn&rsquo;t a fit for our current rolls. <a href="mailto:sales@xesnetting.com">Email us</a> &mdash; we may be able to special-order.</div>';
    } else if (fit === 'depends_on_kit') {
      html += '<div style="margin-top:6px;">' + escapeHtml(row.notes || 'Fitment depends on a width-conversion kit. Confirm your baler config before ordering.') + '</div>';
      if (primary) {
        html += '<div style="margin-top:8px;"><strong>If standard width:</strong> ' + escapeHtml(skuLabel(primary)) + ' &nbsp;<button type="button" class="bpd-apply" data-bpd-apply="' + escapeHtml(primary) + '">Use this size</button></div>';
      }
      if (alt) {
        html += '<div class="bpd-alt"><strong>If converted:</strong> ' + escapeHtml(skuLabel(alt)) + ' &nbsp;<button type="button" class="bpd-apply" data-bpd-apply="' + escapeHtml(alt) + '">Use alternate</button></div>';
      }
    } else if (fit === 'either') {
      if (primary) {
        html += '<div style="margin-top:6px;">Both sizes fit. Recommended: <strong>' + escapeHtml(skuLabel(primary)) + '</strong>.</div>';
        html += '<div style="margin-top:8px;"><button type="button" class="bpd-apply" data-bpd-apply="' + escapeHtml(primary) + '">Use ' + escapeHtml(skuShort(primary)) + '</button></div>';
      }
      if (alt) {
        html += '<div class="bpd-alt">Or: <strong>' + escapeHtml(skuLabel(alt)) + '</strong> &nbsp;<a href="#" data-bpd-apply="' + escapeHtml(alt) + '">use this instead</a></div>';
      }
    } else {
      // single / direct fit
      if (primary) {
        html += '<div style="margin-top:6px;">Direct fit: <strong>' + escapeHtml(skuLabel(primary)) + '</strong>.</div>';
        html += '<div style="margin-top:8px;"><button type="button" class="bpd-apply" data-bpd-apply="' + escapeHtml(primary) + '">Use this size</button></div>';
      }
    }

    if (row.notes && fit !== 'depends_on_kit') {
      html += '<div class="bpd-meta">' + escapeHtml(row.notes) + '</div>';
    }
    html += '</div>';
    resultEl.innerHTML = html;

    track('baler_picker_pdp_result', {
      brand: row.brand, model: row.model,
      recommended_sku: primary, alternate_sku: alt, fit_type: fit
    });
  }

  // --- Wiring ---
  triggerEl.addEventListener('click', function () {
    var open = !ROOT.classList.contains('is-open');
    ROOT.classList.toggle('is-open', open);
    triggerEl.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && !state.loaded) {
      loadData().then(function () {
        populateBrands();
        loadingEl.hidden = true;
        loadingEl.style.display = 'none';
        ctrlsEl.hidden = false;
        track('baler_picker_pdp_open', {});
      }).catch(function (err) {
        loadingEl.textContent = 'Could not load baler list. Please refresh.';
        console.error('[baler-picker-pdp] load failed:', err);
      });
    } else if (open) {
      track('baler_picker_pdp_open', {});
    }
  });

  brandEl.addEventListener('change', function () {
    var brand = brandEl.value;
    populateModels(brand);
    resultEl.innerHTML = '';
  });

  modelEl.addEventListener('change', function () {
    var rowId = modelEl.value;
    if (!rowId) { resultEl.innerHTML = ''; return; }
    var row = state.rows.find(function (r) { return r.id === rowId; });
    renderResult(row);
  });

  resultEl.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bpd-apply]');
    if (!t) return;
    e.preventDefault();
    var sku = t.getAttribute('data-bpd-apply');
    var label = state.skus[sku] ? state.skus[sku].size_label : sku;
    applyVariant(sku, label);
  });
})();
